import { SettingsTab, SettingsGroup } from '@components/layerSettings/StyledLayerSettings';
import PopoverPicker from '@components/popoverPicker/PopoverPicker';
import { useLayerSettingsPortal } from '@hooks/useLayerSettingsPortal';
import useDebounce from '@hooks/useDebounce';
import { COLOR_CHANGE_DEBOUNCE_TIME } from '@config/contoursLayerConfig';
import IntervalSelector from './IntervalSelector';

/**
 * Contours Settings Sidebar Component
 * Provides UI controls for configuring contour layer appearance and detail level
 */
const ContoursSettings = ({
	sidebarId,
	lineColor,
	setLineColor,
	selectedInterval,
	setSelectedInterval,
	availableIntervals,
	contoursConfig,
	isFetching,
}) => {
	const changeColor = useDebounce(setLineColor, COLOR_CHANGE_DEBOUNCE_TIME);

	const getIntervalDescription = () => {
		const config = contoursConfig?.files?.[selectedInterval];
		return config?.description || '';
	};

	const portalContent = useLayerSettingsPortal(
		sidebarId,
		'Contour Settings',
		<SettingsTab>
			<IntervalSelector
				value={selectedInterval}
				onChange={setSelectedInterval}
				options={availableIntervals}
				getDescription={getIntervalDescription}
				disabled={isFetching}
			/>

			<SettingsGroup>
				<PopoverPicker
					label="Contour color"
					color={lineColor}
					onChange={changeColor}
					popDirection="left"
					stackItems={false}
					position="relative"
					pickerStyle={{ width: '100%' }}
				/>
			</SettingsGroup>
		</SettingsTab>
	);

	return portalContent;
};

export default ContoursSettings;
